<wu-modal-layout
  [isOpened]="modalIsOpened()"
  size="xl"
  (dismissed)="closeModal()"
  backgroundOpacity="95"
>
  <!-- Modal Header -->
  <div class="bg-walden-500 px-6 py-4 flex justify-between items-center">
    <h2 class="text-white text-xl font-semibold">Confirm Registration</h2>
    <button
      (click)="closeModal()"
      class="text-white text-2xl hover:opacity-80 transition-opacity"
      aria-label="Close modal"
    >
      ×
    </button>
  </div>

  <!-- Modal Body -->
  <div class="bg-gray-50 p-8 max-h-[600px] overflow-y-auto">
    <!-- Loading State -->
    @if (isLoading()) {
      <div class="flex flex-col items-center justify-center py-12">
        <div
          class="animate-spin rounded-full h-12 w-12 border-b-2 border-walden-500 mb-4"
        ></div>
        <p class="text-gray-600 text-center">
          Loading your registration data...
        </p>
      </div>
    } @else {
      <div class="space-y-8">
        <!-- Registered Courses Section -->
        @if (registeredCourses().length > 0) {
          <div>
            <h3 class="text-gray-800 text-lg font-semibold mb-4">
              Congratulations! You have been registered for the following
              courses:
            </h3>
            <div class="overflow-x-auto border border-gray-300 rounded-md">
              <table class="w-full bg-white">
                <thead>
                  <tr class="bg-gray-100 border-b border-gray-300">
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      Course
                    </th>
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      Start Date
                    </th>
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      End Date
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    course of registeredCourses();
                    track course.courseCode
                  ) {
                    <tr class="border-b border-gray-200 hover:bg-gray-50">
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.courseCode }}-{{ course.courseName }}
                      </td>
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.startDate }}
                      </td>
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.endDate }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (alreadyRegisteredCourses().length > 0) {
          <div>
            <h3 class="text-gray-800 text-lg font-semibold mb-4">
              You have already been registered for the following courses:
            </h3>
            <div class="overflow-x-auto border border-gray-300 rounded-md">
              <table class="w-full bg-white">
                <thead>
                  <tr class="bg-gray-100 border-b border-gray-300">
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      Course
                    </th>
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      Start Date
                    </th>
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      End Date
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    course of alreadyRegisteredCourses();
                    track course.courseCode
                  ) {
                    <tr class="border-b border-gray-200 hover:bg-gray-50">
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.courseCode }}-{{ course.courseName }}
                      </td>
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.startDate }}
                      </td>
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.endDate }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (unregisteredCourses().length > 0) {
          <div>
            <h3 class="text-gray-800 text-lg font-semibold mb-4">
              Unfortunately, we could not register you for the following
              courses:
            </h3>
            <div class="overflow-x-auto border border-gray-300 rounded-md">
              <table class="w-full bg-white">
                <thead>
                  <tr class="bg-gray-100 border-b border-gray-300">
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      Course
                    </th>
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      Start Date
                    </th>
                    <th
                      class="px-4 py-3 text-left text-sm font-semibold text-gray-700"
                    >
                      End Date
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    course of unregisteredCourses();
                    track course.courseCode
                  ) {
                    <tr class="border-b border-gray-200 hover:bg-gray-50">
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.courseCode }}-{{ course.courseName }}
                      </td>
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.startDate }}
                      </td>
                      <td class="px-4 py-3 text-sm text-gray-800">
                        {{ course.endDate }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        <!-- Button -->
        <div class="flex justify-center pt-4">
          <a [href]="SSB_REGISTRATION">
            <button
              class="bg-slate-500 hover:bg-teal-800 text-white font-semibold py-2 px-16 rounded-md transition-colors duration-200"
            >
              MODIFY
            </button>
          </a>
        </div>

        <!-- Error Message -->
        @if (hasError()) {
          <div class="bg-red-50 border border-red-300 rounded-md p-4">
            <p class="text-red-700 text-sm">
              We're sorry, there was an error completing your request. Please
              email your Student Success Advisor at:
              <a
                href="mailto:studentsuccess@mail.waldenu.edu"
                class="underline"
              >
                studentsuccess@mail.waldenu.edu
              </a>
              so your request can be processed.
            </p>
          </div>
        }

        <!-- Footer Text -->
        <div class="border-t border-gray-300 pt-6">
          <p class="text-gray-600 text-sm leading-relaxed">
            You may review and make any changes to your registration by visiting
            the
            <a
              class="text-teal-700 hover:underline font-semibold"
              (click)="closeModal()"
            >
              Student Portal
            </a>
            .
          </p>
          <p class="text-gray-600 text-sm leading-relaxed mt-2">
            If you have any questions around your registration please reach out
            to your Student Success Advisor at
            <a
              href="mailto:studentsuccess@mail.waldenu.edu"
              class="text-teal-700 hover:underline font-semibold"
            >
              studentsuccess@mail.waldenu.edu
            </a>
            .
          </p>
        </div>
      </div>
    }
  </div>
</wu-modal-layout>
